import React, { useState } from 'react'
import './home.scss';
import Swal from 'sweetalert2';
import { Eye, EyeOff, ArrowRight } from 'lucide-react';
import { host } from '../customhooks/Functionapi';

const logo = `${process.env.PUBLIC_URL}/pppi001.png`;

function Home() {
    const [isUserlogin, setIsUserlogin] = useState({ username: "", password: "" })
    const [showPassword, setShowPassword] = useState(false)
    const [loading, setLoading] = useState(false)

    const alertInvalid = () => {
        Swal.fire({
            title: "แจ้งเตือน!",
            text: "แจ้งเตือนเกิดการผิดพลาด กรุณาตรวจสอบ Username and Password",
            icon: "warning"
        });
    }

    const isLogin = (e) => {
        e.preventDefault();
        if (isUserlogin.username == "" || isUserlogin.password == "") {
            alertInvalid();
            return;
        }

        setLoading(true);
        fetch(host + '/user/login', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ username: isUserlogin.username, password: isUserlogin.password })
        }).then(function (res) { return res.json(); })
            .then(function (data) {
                if (data.status == 200) {
                    sessionStorage.setItem("userId", data.data[0].userId)
                    sessionStorage.setItem("userName", data.data[0].name)
                    sessionStorage.setItem("roles", data.data[0].roles)
                    if (data.data[0].roles == 'user') {
                        window.location.href = '/workflow';
                        return;
                    }
                    else if (data.data[0].roles == 'admin') {
                        window.location.href = '/admin';
                        return;
                    } else {
                        Swal.fire({
                            title: "แจ้งเตือน!",
                            text: "คุณยังไม่ได้กำหนดกลุ่ม ผู้ใช้งาน",
                            icon: "warning"
                        });
                    }
                } else if (data.status == 400 || data.status == 401) {
                    alertInvalid();
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                Swal.fire({
                    title: "แจ้งเตือน!",
                    text: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ กรุณาลองใหม่อีกครั้ง",
                    icon: "error"
                });
            })
    }

    return (
        <div className='login-page'>
            <aside className='login-brand'>
                <div className='brand-top'>
                    <img src={logo} alt='PPPi' className='brand-logo' />
                    <div className='brand-company'>
                        <span>Perm Poon Patana</span>
                        <span>Industry Co., Ltd.</span>
                    </div>
                </div>

                <div className='brand-middle'>
                    <p className='brand-eyebrow'>E-Spec Document</p>
                    <h1>ระบบจัดการ<br />เอกสารสเปกสินค้า</h1>
                    <p className='brand-desc'>
                        สร้าง ตรวจสอบ และอนุมัติเอกสาร Spec ตามลำดับขั้นตอน
                        พร้อมติดตามสถานะได้ในที่เดียว
                    </p>
                </div>

                <ul className='brand-steps'>
                    <li><span>01</span>สร้างเอกสาร</li>
                    <li><span>02</span>ตรวจสอบ</li>
                    <li><span>03</span>อนุมัติ</li>
                </ul>
            </aside>

            <main className='login-main'>
                <div className='login-card'>
                    <div className='login-mobile-brand'>
                        <img src={logo} alt='PPPi' />
                        <span>E-Spec Document</span>
                    </div>

                    <h2>เข้าสู่ระบบ</h2>
                    <p className='login-sub'>กรอกชื่อผู้ใช้และรหัสผ่านของคุณ</p>

                    <form onSubmit={(e) => isLogin(e)} noValidate>
                        <div className='field'>
                            <label htmlFor='username'>Username</label>
                            <input
                                id='username'
                                type='text'
                                autoComplete='username'
                                autoFocus
                                value={isUserlogin.username}
                                onChange={(e) => setIsUserlogin({ ...isUserlogin, username: e.target.value })}
                            />
                        </div>

                        <div className='field'>
                            <label htmlFor='password'>Password</label>
                            <div className='input-wrap'>
                                <input
                                    id='password'
                                    type={showPassword ? 'text' : 'password'}
                                    autoComplete='current-password'
                                    value={isUserlogin.password}
                                    onChange={(e) => setIsUserlogin({ ...isUserlogin, password: e.target.value })}
                                />
                                <button
                                    type='button'
                                    className='toggle-pass'
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? 'ซ่อนรหัสผ่าน' : 'แสดงรหัสผ่าน'}
                                >
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>
                        </div>

                        <button type='submit' className='btn-signin' disabled={loading}>
                            {loading ? 'กำลังเข้าสู่ระบบ…' : <>เข้าสู่ระบบ <ArrowRight size={18} /></>}
                        </button>
                    </form>

                    <p className='login-foot'>
                        © {new Date().getFullYear()} Perm Poon Patana Industry Co., Ltd.
                    </p>
                </div>
            </main>
        </div>
    )
}

export default Home
